import { OacJsonResponse } from "../types/demo";
import { ExtractorOacJsonResponse } from "../types/extractorOacResponse";
import { LAElement, LAOacJsonResponse } from "../types/laOacResponse";
import { downloadFile } from "../utils/downloadFile";

export interface UPSTAGEDownloadParams {
  json: OacJsonResponse | null;
  requestId: string | null;
  token?: string | null;
  fileNameWithoutExtenstion: string;
  trans: any;
  endpointType: string;
}

export interface UPSTAGESubmitParams {
  oac: ExtractorOacJsonResponse;
  requestId: string | null;
  token: string | null;
  userId: string | null;
}

export interface SubmitResult {
  code: number;
  message: string;
  ocrExtractResult: SubmitResultHMM | null;
}

interface SubmitResultHMM {
  bookingNumber: string;
  certificateNumber: string;
  emergencyTelephoneNumber: string;
  emergencyContactName: string;
  containers: SubmitResultHMMContainers[];
}

interface SubmitResultHMMContainers {
  containerNumber: string;
  unNumber: string;
  properShippingName: string;
  technicalName: string;
  imdgClass: string;
  subClass: string;
  packageGroup: string;
  marinePollutant: string;
  flashPoint: string;
  limitedQuantity: string;
  emsNumber: string;
  outerQuantity: string;
  outerPackaging: string;
  innerQuantity: string;
  innerPackaging: string;
  grossWeight: string;
  netWeight: string;
}

export const UPSTAGEDownloadEvent = async ({
  json,
  requestId,
  token,
  fileNameWithoutExtenstion,
  trans,
  endpointType,
}: UPSTAGEDownloadParams) => {
  if (endpointType.toLowerCase() === "layout-analysis") {
    const laResult = json as LAOacJsonResponse;
    const html = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Document</title>
        </head>
        <body>
        ${laResult?.elements
          .map((element: LAElement) => {
            console.log("element", element.html);
            return `  ${element.html.replaceAll("\n", "")}`;
          })
          .join("\n")}
        </body>
        </html>
          `;
    const blob = new Blob([html], { type: "text/html" });
    downloadFile({ blob, fileName: `${fileNameWithoutExtenstion}.html` });
  } else {
    const jsonString = JSON.stringify(json, null, 0);
    const blob = new Blob([jsonString], { type: "application/json" });
    downloadFile({ blob, fileName: `${fileNameWithoutExtenstion}.json` });
  }
};

export const HMMDownloadEvent = async ({
  json,
  requestId,
  token,
  fileNameWithoutExtenstion,
  trans,
  endpointType,
}: UPSTAGEDownloadParams) => {
  // HMM 전용
  let downloadUrl = `${process.env.REACT_APP_BACKEND_URL ? process.env.REACT_APP_BACKEND_URL : ""}/api/result/${requestId}/image?token=${token}`;
  try {
    const response = await fetch(downloadUrl);
    if (response.status !== 200) {
      alert(trans(`errors.image_download`));
      return;
    }
    const blob = await response.blob();
    const contentType = response.headers.get("content-type");
    let fileExtension = "";
    // MIME 타입에 따른 파일 확장자 설정
    if (contentType) {
      if (contentType.includes("image/jpeg")) {
        fileExtension = "jpg";
      } else if (contentType.includes("image/png")) {
        fileExtension = "png";
      } else if (contentType.includes("application/pdf")) {
        fileExtension = "pdf";
      } else if (contentType.includes("application/zip")) {
        fileExtension = "zip";
      } else {
        console.warn("Unknown content type:", contentType);
        fileExtension = "bin"; // 기본값으로 이진 파일로 설정
      }
    }

    let filename = response?.headers
      .get("Content-Disposition")
      ?.split("filename=")[1];
    if (!filename) {
      filename = fileNameWithoutExtenstion;
    }

    // 확장자가 이미 파일명에 포함되어 있는지 확인하고, 없으면 추가
    if (!filename.toLowerCase().endsWith(`.${fileExtension}`)) {
      filename += `.${fileExtension}`;
    }

    downloadFile({ blob, fileName: filename });
  } catch (error) {
    console.error(trans(`errors.image_download`), error);
  }
};

export const UPSTAGESubmitEvent = async ({
  oac,
  requestId,
  token,
  userId,
}: UPSTAGESubmitParams) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  if (requestId === null) {
    alert("Invalid request id");
  }
  const submitUrl = `${process.env.REACT_APP_BACKEND_URL ? process.env.REACT_APP_BACKEND_URL : ""}/api/result/${requestId}?token=${token}`;
  if (userId) {
    submitUrl.concat(`&userId=${userId}`);
  }
  const submitResponse: SubmitResult = {
    code: 0,
    message: "",
    ocrExtractResult: null,
  };
  const response = await fetch(submitUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(oac),
  }).then(async resp => {
    const resultResponse = (await resp.json()) as SubmitResult;
    if (200 <= resp.status && resp.status < 300) {
      submitResponse.code = resultResponse.code;
      submitResponse.message = resultResponse.message;
      submitResponse.ocrExtractResult = resultResponse.ocrExtractResult;
    } else {
      submitResponse.code = resultResponse.code;
      submitResponse.message = resultResponse.message;
      submitResponse.ocrExtractResult = null;
    }
  });
  return submitResponse;
};
